import { Button, NonIdealState, Popover, Spinner } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import Padding from "common/fragments/Padding";
import { ButtonVariant } from "common/views/button/Button.view";
import Icon from "common/views/icon/Icon";
import Label from "core/components/label/Label";
import { ForumSubscription } from "panels/forum/entity/ForumSubscription";
import { Component } from "react";
import { MutationType } from "typegraph";
import { FlexJustify } from "../../../../common/fragments/Flex";
import { CardView } from "../../../../common/views/card/Card.view";
import { default as HeadingView, HeadingVariant } from "../../../../common/views/heading/Heading.view";
import { Query } from "../../../../core/api/typedQuery";
import ForumSubscriptionForm from "./ForumSubscriptionForm";
import MutationButton from "common/views/button/MutationButton";
import forumDeletionEvent from "panels/forum/ForumDeletionEvent";


interface IForumSubscriptionManageProps {
	
}

const SubQuery = Query.queryMany<ForumSubscription, any>(ForumSubscription);

export default class ForumSubscriptionManage extends Component<IForumSubscriptionManageProps> {

	private renderForm(sub: ForumSubscription) {
		return (
			<Padding.Base>
				<ForumSubscriptionForm forumId={sub.forumEntity.id} />
			</Padding.Base>
		);
	}

	private renderList(subs: ForumSubscription[],refetch: () => void) {
		return subs.filter((s) => s.forumEntity).map((s) =>
			<CardView key={s.id} viewKey="forum.sub">
				<Padding.Base>
					<FlexJustify>
						<HeadingView viewKey="forum.sub.title" variant={HeadingVariant.H5}>{s.forumEntity.name}</HeadingView>

						<div>
							<Popover content={this.renderForm(s)}>
								<Button minimal={true} icon={IconNames.COG} />
							</Popover>
							<MutationButton
								variant={ButtonVariant.PRIMARY}
								viewKey="forum.sub.delete"
								clazz={ForumSubscription}
								params={{ id: s.id }}
								clearCacheOnSuccess={true}
								method={MutationType.DELETE}
								onSuccess={()=>{
										refetch();
										forumDeletionEvent.notify();
									}
								}
							>
								<Icon icon={IconNames.TRASH} />
							</MutationButton>
						</div>
					</FlexJustify>
				</Padding.Base>
			</CardView>
		);
	}

	public render() {
		return (
			<SubQuery params={{}}>
				{
					({data, loading, refetch}) => {

						if (loading) {
							return <Spinner/>;
						}

						if (!data) {
							return (
								<NonIdealState
									title={<Label k="forum.subs.empty" v="No Subscriptions" />}
									description={<Label k="forum.subs.empty.desc" v="Subscribe to the forum with follow button" />}
								/>
							);
						}

						return this.renderList(data,refetch);
					}
				}
			</SubQuery>
		);
	}
	
}





// WEBPACK FOOTER //
// ./src/panels/forum/component/subscriptions/ForumSubscriptionManage.tsx